module.exports = __webpack_public_path__ + "img/da_vinci.265b9b80.png";